import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const AuthService = {};
AuthService.login = async function (username, password) {
  let data = new FormData();
  data.append("username", username);
  data.append("password", password);

  return axios({
    method: "post",
    url: API_BASE_URL + "/api/auth/login",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

AuthService.refreshToken = async function (refreshToken) {
  let data = new FormData();
  data.append("refreshToken", refreshToken);

  return axios({
    method: "post",
    url: API_BASE_URL + "/api/auth/refresh",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

AuthService.getUserByToken = async () => {
  let data = new FormData();
  const token = localStorage.getItem(ACCESS_TOKEN);
  data.append("token", token);

  return axios({
    method: "post",
    url: API_BASE_URL + "/api/user/get/token",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

AuthService.register = async function (
  lastName,
  firstName,
  middleName,
  contactNumber,
  email,
  birthday,
  gender,
  country,
  city,
  school,
  schoolClass,
  expectedGraduationDate,
  languageSkills,
  foreignLanguageSkills,
  password
) {
  let data = new FormData();
  data.append("lastName", lastName);
  data.append("firstName", firstName);
  if (middleName) {
    data.append("middleName", middleName);
  }
  data.append("contactNumber", contactNumber);
  data.append("email", email);
  data.append("birthday", new Date(birthday).toLocaleDateString());
  data.append("gender", gender);
  data.append("country", country);
  data.append("city", city);
  data.append("school", school);
  if (schoolClass) {
    data.append("schoolClass", schoolClass);
  }
  if (expectedGraduationDate) {
    data.append(
      "expectedGraduationDate",
      new Date(expectedGraduationDate).toLocaleDateString()
    );
  }
  if (languageSkills) {
    data.append("languageSkills", languageSkills);
  }
  if (foreignLanguageSkills) {
    data.append("foreignLanguageSkills", foreignLanguageSkills);
  }
  data.append("password", password);

  return axios({
    method: "post",
    url: API_BASE_URL + "/api/auth/register",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export default AuthService;
